import { DeeplinkService } from './../../services/deeplink.service';
import { Component, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EnvironmentsService } from 'src/app/services/enviroment.service';

@Component({
  selector: 'app-deeplink',
  templateUrl: './deeplink.component.html',
  styleUrls: ['./deeplink.component.scss'],
})
export class DeeplinkComponent {
  deepLinkRev: any;
  tokenHifpt: any;
  link: any;
  code: any;
  screen: any;
  dataGetLink: any;
  opened: any;

  constructor(
    readonly route: ActivatedRoute,
    readonly deeplinkService: DeeplinkService,
    readonly env: EnvironmentsService,
    readonly zone: NgZone,
  ) {


    // @ts-ignore
    window.componentRef = {
      zone: this.zone,
      componentFn: (value: any) => this.initServices(value),
      component: this,
    };

    this.route.queryParamMap.subscribe((res: any) => {
      this.code = this.route.snapshot.paramMap.get('code');
      this.screen = this.route.snapshot.paramMap.get('screen');

      this.tokenHifpt = res.get('test');
      if (this.tokenHifpt) {
        this.initServices(this.tokenHifpt);
      }
    });
    if (
      this.code &&
      this.code !== '' &&
      this.code !== null &&
      this.screen &&
      this.screen !== '' &&
      this.screen !== null
    ) {
      this.dataGetLink = {
        data: {
          short_link_id: this.code.replace(/[^a-zA-Z0-9 ]/g, ''),
          redirect_code: this.screen,
        },
        type_request: 'webkit_get_link',
      };
      // this.dataGetLink = {
      //   short_link_id: this.code.replace(/[^a-zA-Z0-9 ]/g, ''),
      //   redirect_code: this.screen,
      // };
      const isWebkit =
        // @ts-ignore
        window.AndroidBridge ||
          // @ts-ignore
          (window.webkit && !this.checkObjEmpty())
          ? true
          : false;

      if (!isWebkit) {
        this.deeplinkService.getLink(this.dataGetLink).subscribe((res: any) => {
          if (res && res.status === 1) {
            this.deepLinkRev = res.detail.deep_link;
            this.code = undefined;
            this.screen = undefined;
            window.location.href = this.deepLinkRev;

          }
        });

      } else {
        this.deeplinkService.callToken();
        //  this.deeplinkService.callToken();
      }
    }
  }
  initServices(data: string): any {
    if (data) {
      this.tokenHifpt = data;
      this.deeplinkService.getToken(this.tokenHifpt).subscribe((res: any) => {
        if (res && res === 'ok') {
          this.deeplinkService
            .getLinkInApp({ short_link_id: this.code })
            .subscribe((r: any) => {
              if (r && r.status === 1) {
                const a = {
                  action: 'callScreen',
                  data: JSON.stringify(r.detail.data),
                  actionType: r.detail.actionType,
                  title: '',
                  dataAction: r.detail.dataAction,
                };
                this.deeplinkService.callAppFunction(JSON.stringify(a));
              }
            });
        }
      });
    }
  }
  checkObjEmpty(): boolean {
    // @ts-ignore
    if (window.webkit !== undefined) {
      return (
        // @ts-ignore
        Object.keys(window.webkit).length === 0
      );
    } else {
      return false;
    }
  }
}
